import Dict from 'dict-lib';
import {history} from "../history";
import {AdministrationUtilities} from "../../../administration/AdministrationHelper";
import BUtils from "../../../utilities/BaseUtilities";

export const userService = {
    login,
    logout,
    checkReset,
    getAll,
    isLogged,
    unloggedReload,
    getRoleByModule,
    getRoleByContext,
    isAdministrator,
    getTopics,
    getTopicsTree,
    getDefaultTopic,
    changeDefaultTopic,
    getSearchTopics,
    changeSearchTopic,
    getLocalStorage,
    getDictionaryRoles
};

function login(username, password) {
    var credentials = {user: username, password: password};
    return Dict.call('/user/login/' + JSON.stringify(credentials) + '/').then(result => {
        if (result.login === 'OK') {
            document.cookie = "loggedIn=true; path=/; max-age=31536000; SameSite=Lax";

            localStorage.setItem('user', result.user/*JSON.stringify(result.user)*/);
            localStorage.setItem('su', result.su);
            localStorage.setItem('encode', result.encode);
            localStorage.setItem('userRoles', JSON.stringify(result.roles));
            /*localStorage.setItem('topics', JSON.stringify(result.topics));
            localStorage.setItem('topicsTree', JSON.stringify(result.topicsTree));*/

            var defaultTopic = null;
            var searchTopic = null;
            if(typeof result.topics !== 'undefined' && result.topics.length > 0) {
                defaultTopic = typeof result.defaultTopic !== 'undefined' ? JSON.stringify(result.defaultTopic) : null;
                searchTopic = JSON.stringify([]);
            }

            localStorage.setItem('defaultTopic', defaultTopic);
            localStorage.setItem('searchTopic', searchTopic);

            return result.user;
        } else {
            const error = 'error';
            history.push('/login');
            return Promise.reject(error);
        }
    });
}

function logout() {
    document.cookie = "loggedIn=false; path=/; SameSite=Lax";

    // Rimuovi solo le chiavi di autenticazione
    localStorage.removeItem('user');
    localStorage.removeItem('su');
    localStorage.removeItem('encode');
    localStorage.removeItem('userRoles');
    localStorage.removeItem('defaultTopic');
    localStorage.removeItem('searchTopic');

    return Dict.call('/user/logout');
}


function checkReset() {
    if(isLogged()) {
        if(!window.location.href.endsWith('/glossary')) {
            localStorage.defaultTopic = null;
        }
    }
}

function getDefaultTopic() {
    if(window.location.href.endsWith('/glossary')) {
        if (localStorage.getItem("defaultTopic") !== null) {
            var defaultTopic = localStorage.getItem("defaultTopic");
            return defaultTopic;
        } else
            return '';
    } else
        return null;
}

function changeDefaultTopic(topic) {
    localStorage.setItem('defaultTopic', topic);
}

function getSearchTopics() {
    /* Il topic passato nell'URL (es. /glossary/MIOTOPIC) ha priorità ASSOLUTA: quando c'è,
       il topic salvato in localStorage non va mai considerato, altrimenti una scelta fatta
       altrove (es. in un'altra tab sulla pagina generale) filtrerebbe anche la pagina a
       topic fisso. La precedenza sta qui per valere su TUTTI i chiamanti (SearchMenu,
       LexemeShiftButtons, ecc.).
       NB: l'oggetto restituito viene da getTopics() ed è "grezzo"; SearchMenu usa invece
       getTopicsWithSpacer(), che scambia 'label' e 'spacer' per la resa nel typeahead. */
    const urlTopicSlug = AdministrationUtilities.getUrlTopicSlug();
    if (urlTopicSlug !== null) {
        const matched = AdministrationUtilities.getTopics()
            .find((topic) => topic.uniqueDescripion === urlTopicSlug);
        return matched ? [matched] : [];
    }

    if (localStorage.getItem("searchTopic") !== null) {
        var searchTopic = localStorage.getItem("searchTopic");
        return JSON.parse(searchTopic);
    } else
        return [];
}

function changeSearchTopic(idsTopic) {
    localStorage.setItem('searchTopic', JSON.stringify(idsTopic));
}

function getAll() {
    // TODO: Not implemented yet
    console.warn('userService.getAll() is not implemented');
    return Promise.resolve([]);
}

function isLogged() {
    const hasCookie = document.cookie.includes("loggedIn=true");
    const hasEncode = !!localStorage.getItem("encode");
    const hasUser = !!localStorage.getItem("user");
    /* [IFRAME] In iframe l'app è sempre in modalità pubblica/sola lettura.
       Cookie 'loggedIn' e localStorage ('encode', 'user') sono condivisi per
       origine, non per frame: un utente autenticato sulla piattaforma che
       ospita l'iframe risulterebbe loggato — e quindi in editing — anche qui. */
    const isNotInIframe = !BUtils.isInIframe();

    return hasCookie && hasEncode && hasUser && isNotInIframe;
}

function notLoggedHasLoggedIcon() {
    return !isLogged() && document.getElementById("sc-nav-dropdown") !== null;
}

function getRoles() {
    const rolesStr = localStorage.getItem('userRoles');
    return rolesStr ? JSON.parse(rolesStr) : {};
}

function getTopics() {
    return AdministrationUtilities.getTopics();
    /*//TODO provvisorio
    if (typeof localStorage.topics === 'undefined')
        return null;
    else
        return JSON.parse(localStorage.topics);*/
}

function getTopicsTree() {
    //TODO provvisorio
    if (typeof localStorage.topicsTree === 'undefined')
        return null;
    else
        return JSON.parse(localStorage.topicsTree);
}

function getRoleByModule(module) {
    var role = getRoles()[module];
    return (role && role.length > 0 ? role : [{label: Dict.t('NOT_SET')}]);
}

function getRoleByContext(context) {
    return getRoleByModule(context.module);
}

function isAdministrator() {
    return isLogged() && localStorage.su === 'true';
}

function getDictionaryRoles() {
    return getRoles();
}

function getLocalStorage() {
    return localStorage;
}

function unloggedReload() {
    if (notLoggedHasLoggedIcon()) {
        window.location.reload();
    }
}
